/* eslint-disable consistent-return */
import { createSelector } from '@reduxjs/toolkit';
import { defaultUnitDefaultMock } from 'scenes/reportsList/mock/NewReportMocks';
import { ColumnCategory } from 'services/types';
import { ReportColumnItem } from 'shared/types';
import { RootState } from '..';

const configsState = (state: RootState) => state.configsState;

export const refPricingSelector = createSelector([configsState], (state) => {
  const unit = defaultUnitDefaultMock;

  const columnItems: ReportColumnItem[] = state.refPricing.map((rp) => ({
    name: rp.name,
    category: rp.category as ColumnCategory,
    unit,
  }));

  return columnItems;
});
